import { render, staticRenderFns } from "./goods-detail-drawer.vue?vue&type=template&id=26006b90&scoped=true&"
import script from "./goods-detail-drawer.vue?vue&type=script&lang=js&"
export * from "./goods-detail-drawer.vue?vue&type=script&lang=js&"
import style0 from "./goods-detail-drawer.vue?vue&type=style&index=0&id=26006b90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26006b90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26006b90')) {
      api.createRecord('26006b90', component.options)
    } else {
      api.reload('26006b90', component.options)
    }
    module.hot.accept("./goods-detail-drawer.vue?vue&type=template&id=26006b90&scoped=true&", function () {
      api.rerender('26006b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/goods-detail-drawer.vue"
export default component.exports